const GET_PRODUCTS_BY_IDS = '/settings/product/get-service-products-by-ids';
const ADD_TAX_RATE_IN_PRODUCT = '/settings/product/add-tax-rate-in-product';
const GET_SERVICE_PRODUCTS = '/webservice/get-service-products';

module.exports = {
    getServiceProducts: function getServiceProducts(serviceId){
        return window.axios.get(GET_SERVICE_PRODUCTS, {
            params: {
                service_id: serviceId,
            }
        });
    },
    getServiceProductsByIds: function getServiceProductsByIds(serviceId, productIds){
        return window.axios.get(GET_PRODUCTS_BY_IDS, {
            params: {
                service_id: serviceId,
                product_id: productIds
            }
        });
    },
    addTaxRateInProduct: function addTaxRateInProduct(selected_option, id){
        return window.axios.get(ADD_TAX_RATE_IN_PRODUCT, {
            params: {
                service_id: selected_option,
                product_id: id
            }
        });
    }


};  
